import { render, staticRenderFns } from "./VendorSubmitted.vue?vue&type=template&id=72f613c0"
import script from "./VendorSubmitted.vue?vue&type=script&lang=js"
export * from "./VendorSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports